import React, { useState } from 'react';
import { sendResetPasswordCode } from 'actions/auth';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Robot from 'style/imgs/Backpack.svg';

import buttons from 'style/buttons.module.scss';
import styles from '../signUp/index.module.scss';

interface ILocationState {
  email: string;
}

const SendEmail: React.FC = () => {
  const dispatch = useDispatch();
  const location = useLocation<ILocationState>();
  const [isTimerOn, setisTimerOn] = useState(false);

  const onSubmit = async (e: React.MouseEvent) => {
    e.preventDefault();
    await dispatch(sendResetPasswordCode(location.state.email));
    setisTimerOn(true);
    setTimeout(() => {
      setisTimerOn(false);
    }, 60000);
  };

  return (
    <div className={styles.signUp}>
      <div className={styles.signUpLeft}>
        <div className={styles.robot}>
          <img src={Robot} alt="img" />
        </div>
      </div>
      <div className={styles.signUpRight}>
        <div>
          <div className={styles.trapezoid}>
            <form className={styles.sendMail}>
              <h1 className="deep-gray-heading">Link was sent to your email</h1>
              <span className="gray-text">
                Please, check your email and use the link inside to change the
                password.
              </span>
              <button
                type="submit"
                className={buttons.buttomPrimary}
                style={{ width: '365px' }}
                onClick={onSubmit}
                disabled={isTimerOn}
              >
                {isTimerOn ? 'Please wait 1 minute' : 'Send again'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendEmail;
